import AdminResultsPage from './AdminResultsPage';

export default AdminResultsPage;
